interface IFormTitleProps {
  spacing?: 'md' | 'sm';
  title: string;
}

export const FormTitle = ({ spacing = 'md', title }: IFormTitleProps) => {
  return (
    <h3 className={`text-2xl text-center font-semibold leading-7 text-gray-900 my-8 ${spacing === 'sm' ? 'mb-4' : ''}`}>
      {title}
    </h3>
  );
};
